import QrScan from 'react-qr-reader'
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";

export default function ScannerPage() {

    const navigate = useNavigate();
    const [isUser, setIsUser] = useState(false)
    useEffect(() => {
        CheckUser()
    }, [])
    const CheckUser = () => {
        const Security = localStorage.getItem("secret");
        if (Security === "ffb1f3c7cd3d6e869bcd03250e6054f1d5403025") {
            setIsUser(true)
        }
    }

    const handleScan = data => {
        if (data) {
            if (data.includes("https://intcie.com/")) {
                toast("درحال بارگیری اطلاعات ...")
                navigate("/resualt", {state: `${data}?secret=ffb1f3c7cd3d6e869bcd03250e6054f1d5403025`})

            } else {
                toast("این اپلیکیشن برای QRcode شما طراحی نشده است.")
            }
        }
    }
    const handleError = err => {
        console.error(err)
    }
    const LogOute = () => {
        localStorage.clear();
        window.location.reload();
    }
    return (
        <div>
            {isUser ?
                <div className="text-center d-block">
                    <button className="p-lg-btn " onClick={LogOute}>
                        خروج از حساب
                    </button>
                </div>
                :
                null
            }
            <center>
                <div style={{marginTop: 30}}>
                    <QrScan
                        scanDelay={500}
                        onScan={handleScan}
                        onError={handleError}
                        style={{height: 240, width: "auto"}}
                    />
                </div>
            </center>
        </div>
    );
}

